import { setActiveSubscription } from "../../../actions";
import ApiCall from "../../../utils/apiCall";

export function setChurnReminder() {
  return (dispatch, getState) => {
    const { currentSubscription } = getState().settings;

    return ApiCall.put("/stores/churn_reminder")
      .then(res => dispatch(setActiveSubscription({ ...currentSubscription, churn_reminder_enabled: true })))
  };
}



// WEBPACK FOOTER //
// ./src/newDropshipperApp/module/store/churnReminder.js